var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEolCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 68,
    viewBox: "0 0 103 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1516_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 103,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.625 0H1.62451V68H103.625V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1516_2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3612 10C44.6357 10 44.8581 10.2239 44.8581 10.5V12.5C44.8581 12.7761 44.6357 13 44.3612 13C44.0868 13 43.8643 12.7761 43.8643 12.5V10.5C43.8643 10.2239 44.0868 10 44.3612 10Z",
    fill: "url(#paint0_linear_1516_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3612 15C44.6357 15 44.8581 15.2239 44.8581 15.5V17.5C44.8581 17.7761 44.6357 18 44.3612 18C44.0868 18 43.8643 17.7761 43.8643 17.5V15.5C43.8643 15.2239 44.0868 15 44.3612 15Z",
    fill: "url(#paint1_linear_1516_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3857 14C40.3857 13.7239 40.6083 13.5 40.8827 13.5H42.8704C43.1449 13.5 43.3674 13.7239 43.3674 14C43.3674 14.2761 43.1449 14.5 42.8704 14.5H40.8827C40.6083 14.5 40.3857 14.2761 40.3857 14Z",
    fill: "url(#paint2_linear_1516_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.355 14C45.355 13.7239 45.5775 13.5 45.8519 13.5H47.8397C48.1142 13.5 48.3366 13.7239 48.3366 14C48.3366 14.2761 48.1142 14.5 47.8397 14.5H45.8519C45.5775 14.5 45.355 14.2761 45.355 14Z",
    fill: "url(#paint3_linear_1516_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0365 32.4834C97.311 32.4834 97.5334 32.7073 97.5334 32.9834V33.9834C97.5334 34.2595 97.311 34.4834 97.0365 34.4834C96.7621 34.4834 96.5396 34.2595 96.5396 33.9834V32.9834C96.5396 32.7073 96.7621 32.4834 97.0365 32.4834Z",
    fill: "#00DBD1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0365 36.4834C97.311 36.4834 97.5334 36.7073 97.5334 36.9834V37.9834C97.5334 38.2595 97.311 38.4834 97.0365 38.4834C96.7621 38.4834 96.5396 38.2595 96.5396 37.9834V36.9834C96.5396 36.7073 96.7621 36.4834 97.0365 36.4834Z",
    fill: "#00DBD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0547 35.4834C94.0547 35.2073 94.2772 34.9834 94.5516 34.9834H95.5455C95.82 34.9834 96.0424 35.2073 96.0424 35.4834C96.0424 35.7595 95.82 35.9834 95.5455 35.9834H94.5516C94.2772 35.9834 94.0547 35.7595 94.0547 35.4834Z",
    fill: "#00DBD1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0303 35.4834C98.0303 35.2073 98.2528 34.9834 98.5272 34.9834H99.5211C99.7956 34.9834 100.018 35.2073 100.018 35.4834C100.018 35.7595 99.7956 35.9834 99.5211 35.9834H98.5272C98.2528 35.9834 98.0303 35.7595 98.0303 35.4834Z",
    fill: "#00DBD1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2845 11.6413C80.6155 12.4854 81.8028 12.4854 82.1337 11.6413L82.7374 10.1011C82.8385 9.84338 83.0412 9.63938 83.2973 9.53768L84.8281 8.93028C85.667 8.59728 85.667 7.40268 84.8281 7.06968L83.2973 6.46228C83.0412 6.36058 82.8385 6.15658 82.7374 5.89888L82.1337 4.35868C81.8028 3.51455 80.6155 3.51455 80.2845 4.35868L79.6808 5.89888C79.5799 6.15658 79.377 6.36058 79.1209 6.46228L77.5901 7.06968C76.7512 7.40268 76.7512 8.59728 77.5901 8.93028L79.1209 9.53768C79.377 9.63938 79.5799 9.84338 79.6808 10.1011L80.2845 11.6413Z",
    fill: "url(#paint4_linear_1516_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8688 35.7693C30.3092 35.4914 32.4055 35.3725 33.8925 35.3052L33.9371 36.3042C32.4382 36.372 30.414 36.4894 29.056 36.7514C28.7188 36.8165 28.437 36.8879 28.2216 36.9645C28.1319 36.9963 28.0625 37.0261 28.0098 37.0521C28.0634 37.0935 28.1345 37.1415 28.2268 37.1957C28.9254 37.6054 29.6214 37.9084 30.2387 38.1514C30.4606 38.2387 30.6817 38.3215 30.8909 38.3999C31.2389 38.5304 31.5543 38.6486 31.7862 38.7547C31.9697 38.8387 32.1758 38.9465 32.3226 39.0937C32.401 39.1724 32.489 39.2883 32.5286 39.4455C32.571 39.6145 32.5439 39.7776 32.477 39.915C32.364 40.1473 32.1372 40.3058 31.9439 40.4194C31.7274 40.5466 31.4391 40.6799 31.0814 40.8253C30.5277 41.0503 30.3322 41.2596 30.2661 41.3879C30.2122 41.4928 30.2028 41.6264 30.2951 41.8542C30.3923 42.0945 30.5676 42.3533 30.7818 42.6607C30.792 42.6752 30.8022 42.69 30.8127 42.7049C31.0021 42.9763 31.2277 43.2995 31.3556 43.6165L30.4349 43.9929C30.3518 43.7872 30.1874 43.5496 29.9681 43.2348L29.9654 43.2309C29.7655 42.9442 29.5211 42.5935 29.3745 42.2313C29.2223 41.8549 29.1453 41.391 29.3837 40.928C29.61 40.4883 30.0669 40.1591 30.7091 39.8981C30.9608 39.7958 31.1554 39.7081 31.3023 39.6326C31.1105 39.549 30.8782 39.4622 30.5998 39.3582C30.3866 39.2785 30.1464 39.1888 29.8766 39.0826C29.2357 38.8303 28.4871 38.5059 27.7263 38.0596C27.4216 37.8809 27.1452 37.6679 27.0061 37.3957C26.929 37.2447 26.89 37.0665 26.9251 36.8775C26.9593 36.6938 27.0542 36.5499 27.1562 36.444C27.3468 36.2462 27.625 36.1159 27.8907 36.0215C28.1713 35.9219 28.5064 35.8393 28.8688 35.7693Z",
    fill: "#2FD665"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.006 18.9453C102.555 18.9453 103 18.4976 103 17.9453C103 17.393 102.555 16.9453 102.006 16.9453C101.457 16.9453 101.012 17.393 101.012 17.9453C101.012 18.4976 101.457 18.9453 102.006 18.9453Z",
    fill: "#FF6600"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0168 18C65.5657 18 66.0107 17.5523 66.0107 17C66.0107 16.4477 65.5657 16 65.0168 16C64.4679 16 64.0229 16.4477 64.0229 17C64.0229 17.5523 64.4679 18 65.0168 18Z",
    fill: "#FFFF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5202 4C19.0691 4 19.5141 3.55228 19.5141 3C19.5141 2.44772 19.0691 2 18.5202 2C17.9713 2 17.5264 2.44772 17.5264 3C17.5264 3.55228 17.9713 4 18.5202 4Z",
    fill: "#8CFF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61838 46.9453C3.16728 46.9453 3.61226 46.4976 3.61226 45.9453C3.61226 45.393 3.16728 44.9453 2.61838 44.9453C2.06948 44.9453 1.62451 45.393 1.62451 45.9453C1.62451 46.4976 2.06948 46.9453 2.61838 46.9453Z",
    fill: "#00DBD1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1516_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 26,
    width: 32,
    height: 31
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.886 26H48.082V56.624H79.886V26Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1516_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8933 41.8359C57.7677 43.0932 60.3563 44 63.984 44C67.6116 44 70.2002 43.0932 72.0747 41.8359C73.9616 40.5702 75.2443 38.8683 76.1203 37.1056C77.0002 35.335 77.45 33.5402 77.6768 32.1712C77.6863 32.1133 77.6956 32.0562 77.7043 32H50.2636C50.2723 32.0562 50.2816 32.1133 50.2911 32.1712C50.5179 33.5402 50.9677 35.335 51.8476 37.1056C52.7236 38.8683 54.0063 40.5702 55.8933 41.8359ZM48.2538 32C48.859 36.2921 51.5974 46 63.984 46C76.3705 46 79.1088 36.2921 79.7141 32C79.886 30.7819 79.886 30 79.886 30H48.0882C48.0861 30 48.084 30 48.082 30C48.082 30 48.082 30.7819 48.2538 32Z",
    fill: "#E4A813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9162 26H53.051C52.5021 26 52.0571 26.4477 52.0571 27C52.0571 27.5523 52.5021 28 53.051 28H74.9162C75.4651 28 75.9101 27.5523 75.9101 27C75.9101 26.4477 75.4651 26 74.9162 26Z",
    fill: "#E4A813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9408 54.624H57.0266C56.4777 54.624 56.0327 55.0717 56.0327 55.624C56.0327 56.1763 56.4777 56.624 57.0266 56.624H70.9408C71.4897 56.624 71.9347 56.1763 71.9347 55.624C71.9347 55.0717 71.4897 54.624 70.9408 54.624Z",
    fill: "#E4A813"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0728 54.6235H69.8955C67.0151 54.5769 65.5382 50.6442 64.781 46.6235H63.1872C62.4299 50.6442 60.9531 54.5769 58.0728 54.6235Z",
    fill: "#E6B51C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9836 48C54.0449 48 54.0449 28 54.0449 28H73.9224C73.9224 28 73.9224 48 63.9836 48Z",
    fill: "#F4C620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5387 30.851C63.7209 30.4794 64.2476 30.4794 64.4299 30.851L65.6212 33.2797C65.6936 33.4273 65.8335 33.5296 65.9953 33.5532L68.6592 33.9427C69.0668 34.0023 69.2296 34.5063 68.9346 34.7956L67.007 36.6861C66.8899 36.8009 66.8364 36.9664 66.8641 37.1286L67.3191 39.7981C67.3887 40.2065 66.9627 40.518 66.5981 40.3251L64.2155 39.0648C64.0707 38.9882 63.8977 38.9882 63.753 39.0648L61.3704 40.3251C61.0058 40.518 60.5797 40.2065 60.6494 39.7981L61.1044 37.1286C61.132 36.9664 61.0786 36.8009 60.9614 36.6861L59.0339 34.7956C58.7389 34.5063 58.9017 34.0023 59.3093 33.9427L61.9731 33.5532C62.135 33.5296 62.2749 33.4273 62.3473 33.2797L63.5387 30.851Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1516_2",
    x1: 45.0277,
    y1: 10,
    x2: 43.7064,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1516_2",
    x1: 45.0277,
    y1: 15,
    x2: 43.7064,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1516_2",
    x1: 40.3857,
    y1: 13.3294,
    x2: 40.3857,
    y2: 14.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1516_2",
    x1: 45.355,
    y1: 13.3294,
    x2: 45.355,
    y2: 14.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF536B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1516_2",
    x1: 75.2459,
    y1: 16.0471,
    x2: 75.2459,
    y2: 0.094103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 68,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEolCompleted);
export default __webpack_public_path__ + "static/media/eol-completed.52cfbb43380cfa33469b4a2c4bf941b5.svg";
export { ForwardRef as ReactComponent };